import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "backdrop"];

  static classes = ["hidden"];

  open() {
    this.menuTarget.classList.remove(this.hiddenClass);
    this.backdropTarget.classList.remove(this.hiddenClass);
  }

  close() {
    this.menuTarget.classList.add(this.hiddenClass);
    this.backdropTarget.classList.add(this.hiddenClass);
  }
}
